module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter"
    }
  }, [_c('p', {
    staticClass: "sp"
  }), _vm._v(" "), _c('header', [_c('h1', {
    staticClass: "FMH"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#c_abb"
    }
  }, [_vm._v("Abbreviations")])])]), _vm._v(" "), _c('figure', {
    staticClass: "table"
  }, [_c('table', {
    staticClass: "Basic-Table",
    attrs: {
      "id": "table001"
    }
  }, [_c('tbody', [_c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table col5"
  }, [_c('p', {
    staticClass: "ABBL"
  }, [_c('i', [_vm._v("CA")])])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table col95"
  }, [_c('p', {
    staticClass: "ABBL"
  }, [_vm._v("John Paul II, "), _c('i', [_vm._v("Centesimus Annus")]), _vm._v(" (1991)")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "ABBL"
  }, [_c('i', [_vm._v("CV")])])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "ABBL"
  }, [_vm._v("Benedict XVI, "), _c('i', [_vm._v("Caritas in Veritate")]), _vm._v(" (2009)")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "ABBL"
  }, [_c('i', [_vm._v("DC")])])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "ABBL"
  }, [_vm._v("Benedict XVI, "), _c('i', [_vm._v("Deus Caritas Est")]), _vm._v(" (2005)")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "ABBL"
  }, [_c('i', [_vm._v("DM")])])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "ABBL"
  }, [_vm._v("John Paul II, "), _c('i', [_vm._v("Dives in Misericordia")]), _vm._v(" (1980)")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "ABBL"
  }, [_c('i', [_vm._v("EA")])])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "ABBL"
  }, [_vm._v("John Paul II, "), _c('i', [_vm._v("Ecclesia in America")]), _vm._v(" (1999)")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "ABBL"
  }, [_c('i', [_vm._v("EG")])])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "ABBL"
  }, [_vm._v("Francis, "), _c('i', [_vm._v("Evangelii Gaudium")]), _vm._v(" (2013)")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "ABBL"
  }, [_c('i', [_vm._v("LE")])])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "ABBL"
  }, [_vm._v("John Paul II, "), _c('i', [_vm._v("Laborem Exercens")]), _vm._v(" (1981)")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "ABBL"
  }, [_c('i', [_vm._v("LS")])])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "ABBL"
  }, [_vm._v("Francis, "), _c('i', [_vm._v("Laudato Si’")]), _vm._v(" (2015)")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "ABBL"
  }, [_c('i', [_vm._v("MM")])])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "ABBL"
  }, [_vm._v("John XXIII, "), _c('i', [_vm._v("Mater et Magistra")]), _vm._v(" (1961)")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "ABBL"
  }, [_c('i', [_vm._v("PP")])])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "ABBL"
  }, [_vm._v("Paul VI, "), _c('i', [_vm._v("Populorum Progressio")]), _vm._v(" (1967)")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "ABBL"
  }, [_c('i', [_vm._v("QA")])])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "ABBL"
  }, [_vm._v("Pius XI, "), _c('i', [_vm._v("Quadragesimo Anno")]), _vm._v(" (1931)")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "ABBL"
  }, [_c('i', [_vm._v("RH")])])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "ABBL"
  }, [_vm._v("John Paul II, "), _c('i', [_vm._v("Redemptor Hominis")]), _vm._v(" (1979)")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "ABBL"
  }, [_c('i', [_vm._v("RN")])])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "ABBL"
  }, [_vm._v("Leo XIII, "), _c('i', [_vm._v("Rerum Novarum")]), _vm._v(" (1891)")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "ABBL"
  }, [_c('i', [_vm._v("SRS")])])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "ABBL"
  }, [_vm._v("John Paul II, "), _c('i', [_vm._v("Sollicitudo Rei Socialis")]), _vm._v(" (1987)")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "ABBL"
  }, [_c('i', [_vm._v("SS")])])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "ABBL"
  }, [_vm._v("Benedict XVI, "), _c('i', [_vm._v("Spe Salvi")]), _vm._v(" (2007)")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "ABBL"
  }, [_c('i', [_vm._v("VS")])])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "ABBL"
  }, [_vm._v("John Paul II, "), _c('i', [_vm._v("Veritatis Splendor")]), _vm._v(" (1993)")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "ABBLL"
  }, [_vm._v("All references to the Bible, unless otherwise noted, are from the "), _c('i', [_vm._v("New American Bible")]), _vm._v(", the translation used in the worship and prayer of US Catholics, available on the US Conference of Catholic Bishops website at "), _c('a', {
    attrs: {
      "href": "http://usccb.org/bible/index.cfm",
      "target": "_blank"
    }
  }, [_vm._v("http://usccb.org/bible/index.cfm")]), _vm._v(".")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06801598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/abbreviations.vue
// module id = 75
// module chunks = 0